import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ConfigService } from '../../shared/services/config.service';
import { CookieConsentBannerComponent } from '../../shared/components/cookie-constent-banner/cookie-consent-banner.component';
import packageInfo from '../../../../package.json';
import { GeneralService as InvoiceGeneralService } from '../../../api-invoice';
import { ApiMainGeneralService } from '../../shared/services/api-main-general.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CookieConsentBannerComponent],
})
export class FooterComponent implements OnInit, OnDestroy {
  private http = inject(HttpClient);
  private mainGeneralService = inject(ApiMainGeneralService);
  private invoiceGeneralService = inject(InvoiceGeneralService);

  version = 'loading..';

  unsubscribe: Subject<void> = new Subject<void>();

  constructor() {
    this.invoiceGeneralService = new InvoiceGeneralService(
      this.http,
      ConfigService.getApiInvoiceConfig(),
      undefined,
    );
  }

  ngOnInit(): void {
    this.invoiceGeneralService
      .generalControllerGetVersion()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (respInvoice) => {
          this.mainGeneralService
            .getVersion()
            .pipe(takeUntil(this.unsubscribe))
            .subscribe({
              next: (respMain) => {
                this.version =
                  'F: ' +
                  packageInfo.version +
                  ', B: ' +
                  respMain.app_version +
                  ', I: ' +
                  respInvoice.app_version;
              },
            });
        },
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
